import { NavBar, Tab, Tabs, Grid, GridItem } from 'vant';
import { drawBar, drawPie, drawPictorialBar, drawPolarBar, drawHxPie, drawHBar } from "@/utils/chartTool";
import axios from "axios";
export default {
  components: {
    NavBar,
    Tab,
    Tabs,
    Grid,
    GridItem
  },

  data() {
    return {
      chartAllData: {}
    };
  },

  mounted() {
    axios.get("/api/yglx").then(res => {
      this.chartAllData = res.data;
      drawHxPie("chartYglx", {
        data: this.chartAllData.chartYglx,
        name: "员工类型"
      });
      drawPictorialBar("chartXbfb", {
        data: this.chartAllData.chartXbfb,
        name: "性别分布"
      });
      drawPie("chartNlgc", {
        data: this.chartAllData.chartNlgc,
        name: "年龄构成"
      });
      drawBar("chartXlfb", {
        data: this.chartAllData.chartXlfb,
        name: "学历分布"
      });
      drawHBar("chartTxryqs", {
        data: this.chartAllData.chartTxryqs,
        name: "距离退休"
      });
    });
  },

  created() {},

  methods: {}
};